import { Check } from "lucide-react";
import { BREEDING_METHODS } from "./constants";

export const BreedingServiceSection = ({ formData, update, isStud, isMare, isStudOrMare }) => (
  <>
    {isStud && (
      <div className="glass-card p-6 space-y-6">
        <h2 className="text-xl text-[#EDEDED] mb-4">Stud Service Details</h2>

        <div>
          <label className="block text-sm text-[#A1A1AA] mb-2">Breeding Method *</label>
          <div className="grid grid-cols-3 gap-3">
            {BREEDING_METHODS.map((method) => (
              <label
                key={method.value}
                className={`p-3 rounded-lg border cursor-pointer text-center transition-all ${
                  formData.breeding_method === method.value
                    ? "border-[#D4AF37] bg-[#D4AF37]/10"
                    : "border-[#3F3F46] hover:border-[#71717A]"
                }`}
              >
                <input
                  type="radio"
                  name="breeding_method"
                  value={method.value}
                  checked={formData.breeding_method === method.value}
                  onChange={(e) => update({ breeding_method: e.target.value })}
                  className="sr-only"
                />
                <span className="text-sm text-[#EDEDED]">{method.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm text-[#A1A1AA] mb-2">Requirements for Mares</label>
          <textarea
            value={formData.requirements_for_mares}
            onChange={(e) => update({ requirements_for_mares: e.target.value })}
            className="input-minimal min-h-[100px]"
            placeholder="Describe any requirements for mares (health tests, registration, etc.)"
          />
        </div>
      </div>
    )}

    {isMare && (
      <div className="glass-card p-6 space-y-6">
        <h2 className="text-xl text-[#EDEDED] mb-4">Mare Service Details</h2>

        <div>
          <label className="block text-sm text-[#A1A1AA] mb-2">Reproductive History</label>
          <textarea
            value={formData.reproductive_history}
            onChange={(e) => update({ reproductive_history: e.target.value })}
            className="input-minimal min-h-[100px]"
            placeholder="Previous foals, breeding success, any reproductive issues..."
          />
        </div>

        <div>
          <label className="block text-sm text-[#A1A1AA] mb-2">Boarding Expectations</label>
          <textarea
            value={formData.boarding_expectations}
            onChange={(e) => update({ boarding_expectations: e.target.value })}
            className="input-minimal min-h-[100px]"
            placeholder="Describe boarding arrangements, care requirements..."
          />
        </div>

        <div>
          <label className="block text-sm text-[#A1A1AA] mb-2">Partnership / Service Terms</label>
          <textarea
            value={formData.partnership_terms}
            onChange={(e) => update({ partnership_terms: e.target.value })}
            className="input-minimal min-h-[100px]"
            placeholder="Describe partnership terms, service agreements..."
          />
        </div>
      </div>
    )}

    {isStudOrMare && (
      <div className="glass-card p-6 space-y-6">
        <h2 className="text-xl text-[#EDEDED] mb-4">Availability</h2>

        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={formData.in_season}
            onChange={(e) => update({ in_season: e.target.checked })}
            className="sr-only"
          />
          <div
            className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all ${
              formData.in_season ? "bg-[#22C55E] border-[#22C55E]" : "border-[#71717A]"
            }`}
          >
            {formData.in_season && <Check className="w-4 h-4 text-black" />}
          </div>
          <div>
            <span className="text-[#EDEDED]">Currently in season / accepting breeding</span>
            <p className="text-xs text-[#71717A]">Enable this to show "Available Now" badge</p>
          </div>
        </label>

        <div className={`grid grid-cols-2 gap-4 ${!formData.in_season ? "opacity-50 pointer-events-none" : ""}`}>
          <div>
            <label className="block text-sm text-[#A1A1AA] mb-2">Available From</label>
            <input
              type="date"
              value={formData.available_from}
              onChange={(e) => update({ available_from: e.target.value })}
              className="input-minimal"
              disabled={!formData.in_season}
            />
          </div>
          <div>
            <label className="block text-sm text-[#A1A1AA] mb-2">Available To</label>
            <input
              type="date"
              value={formData.available_to}
              onChange={(e) => update({ available_to: e.target.value })}
              className="input-minimal"
              disabled={!formData.in_season}
            />
          </div>
        </div>
      </div>
    )}
  </>
);
